export default __webpack_public_path__ + "static/media/live_icon.5153324a.svg";